// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Arsi","footer":"styles_footer__2FiB_","passCodeTooltip":"styles_passCodeTooltip__1Ud43"};